<template>
  <div class="green lighten-4">
    <v-container style="max-width: 1800px">
      <v-btn
        class="white mr-2"
        active-class="white--text primary"
        link
        :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/rental/meter/water`"
        outlined
        elevation="0"
        
        >{{ $t('meter.record_water_meter') }}</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/rental/meter/elec`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('meter.record_elec_meter') }}</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/rental/invoices`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('invoice.title') }}</v-btn
      >
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  }
};
</script>

<style lang="scss" scoped>
.tool-bar{
  background-color: rgb(233,249,238);
  border: 1px solid rgb(221,242,228);
}
</style>
